import DealerView from '@/views/app/dealer/dealer.view'
import DealerGuards from '@/guards/dealer.guards'

export default [
  {
    path: 'dealer',
    name: 'dealer',
    component: DealerView,
    beforeEnter: DealerGuards.dealerGuard
  }
]



// WEBPACK FOOTER //
// ./src/router/app/dealer/index.js